import { RefObject, useEffect } from "react";

export const useClickOutside = (ref: RefObject<HTMLElement>, handleClickOutside: () => void) => {
  useEffect(() => {
    const handle = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handleClickOutside();
      }
    };

    document.addEventListener("mousedown", handle);

    return () => {
      document.removeEventListener("mousedown", handle);
    };
  }, [ref, handleClickOutside]);
};
